import React, { useState } from 'react';
import { motion } from 'framer-motion';
import copy from 'copy-to-clipboard';
import Layout from '../components/Layout';
import Textarea from '../components/Textarea';
import Button from '../components/Button';
import { trimWhitespace } from '../utils/textUtils';

const WhitespaceRemover: React.FC = () => {
  const [text, setText] = useState('');
  const [result, setResult] = useState('');
  const [showToast, setShowToast] = useState(false);

  const handleRemove = (type: keyof typeof trimWhitespace) => {
    const cleaned = trimWhitespace[type](text);
    setResult(cleaned);
  };

  const handleCopy = () => {
    copy(result);
    setShowToast(true);
    setTimeout(() => setShowToast(false), 2000);
  };

  return (
    <Layout showBackButton>
      <div className="max-w-4xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="mb-32"
        >
          <h1 className="text-4xl font-bold text-textPrimary mb-8">공백 정리</h1>
          <p className="text-textSecondary">
            불필요한 공백을 깔끔하게 정리합니다
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 }}
          className="mb-24"
        >
          <Textarea value={text} onChange={setText} />
        </motion.div>

        {text && (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="mb-24"
          >
            <div className="flex flex-wrap gap-12 mb-24">
              <Button onClick={() => handleRemove('trimStartEnd')}>
                앞뒤 공백 제거
              </Button>
              <Button onClick={() => handleRemove('removeAll')}>
                모든 공백 제거
              </Button>
              <Button onClick={() => handleRemove('removeMultiple')}>
                중복 공백 정리
              </Button>
              <Button onClick={() => handleRemove('removeNewlines')}>
                줄바꿈 제거
              </Button>
            </div>

            {result && (
              <div>
                <label className="block text-textSecondary mb-8 text-sm">
                  정리된 텍스트
                </label>
                <Textarea value={result} onChange={setResult} />
                <div className="mt-12">
                  <Button onClick={handleCopy}>결과 복사</Button>
                </div>
              </div>
            )}
          </motion.div>
        )}

        {showToast && (
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0 }}
            className="fixed bottom-32 left-1/2 transform -translate-x-1/2 bg-textPrimary text-white px-24 py-12 rounded-medium shadow-lg"
          >
            ✓ 복사됨
          </motion.div>
        )}
      </div>
    </Layout>
  );
};

export default WhitespaceRemover;
